// @mui
import { Box, Typography, Stack } from '@mui/material';
// assets
import { UploadIllustration } from '../../assets';

// ----------------------------------------------------------------------

export default function BlockContent() {
  return (
    <Stack
      spacing={2}
      alignItems="center"
      justifyContent="center"
      direction={{ xs: 'column', md: 'row' }}
      sx={{ width: 1, textAlign: { xs: 'center', md: 'left' } }}
    >
      <UploadIllustration sx={{ width: 100 }} />

      <Box sx={{ p: 3 }}>
        <Typography gutterBottom variant="subtitle">
        Arraste arquivos ou selecione buscando em sua máquina
        </Typography>

 
      </Box>
    </Stack>
  );
}
